import * as React from "react";
const SvgFiRrBowlScoops = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bowl-scoops_svg__a)">
      <path
        fill="#062147"
        d="M22.138 13H1.862a1.862 1.862 0 0 0-1.735 2.537s.169.423.198.472c1.623 2.706 3.926 2.964 5.973 2.992h4.7v3h-3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-3h4.716c2.032-.028 4.337-.286 5.959-2.992.029-.049.198-.472.198-.472a1.86 1.86 0 0 0-.198-1.726A1.86 1.86 0 0 0 22.137 13m-.222 2.049C20.922 16.66 19.705 16.972 17.7 17H6.313c-2.018-.028-3.235-.34-4.23-1.951L2.066 15h19.87zm-21.2-4.09a.994.994 0 0 0 1.243-.677C2.528 8.349 4.395 7 6.499 7c2.106 0 3.973 1.35 4.542 3.282a1 1 0 0 0 1.918 0C13.528 8.349 15.395 7 17.499 7c2.106 0 3.973 1.35 4.542 3.282a1 1 0 1 0 1.918-.564c-.74-2.515-2.99-4.326-5.623-4.65A6.456 6.456 0 0 0 12 .001a6.456 6.456 0 0 0-6.336 5.067C3.03 5.392.78 7.203.04 9.718a1 1 0 0 0 .676 1.241M12 2a4.47 4.47 0 0 1 4.277 3.122c-1.734.315-3.274 1.273-4.277 2.652-1.004-1.379-2.543-2.337-4.277-2.652A4.465 4.465 0 0 1 12 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bowl-scoops_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowlScoops;
